// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2EpZ_","topBottomGutter":"Layout_topBottomGutter__WdjRX"};